import React from 'react';
import styled from 'styled-components';
import { useThemeContext } from '@/contexts/ThemeContext';
import { isInIframe } from '@/Utils/iframe-utils';

const DebugContainer = styled.div`
  position: fixed;
  bottom: 10px;
  left: 10px;
  background: ${({ theme }) => theme.colors.bgSecondary};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  color: ${({ theme }) => theme.colors.grayDarkerFont};
  z-index: ${({ theme }) => theme.zIndex.fixed};
  max-width: 300px;
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;

const DebugTitle = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
`;

const DebugRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  padding: ${({ theme }) => theme.spacing.xs};
  background: ${({ theme }) => theme.colors.bgPrimary};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
`;

const DebugLabel = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.muted};
`;

const DebugValue = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`;

const StatusBadge = styled.span<{ $active: boolean }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: ${({ theme }) => theme.borderRadius.pill};
  background: ${({ $active, theme }) => 
    $active ? theme.colors.success : theme.colors.error};
  color: white;
  font-size: 10px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`;

export const IframeDebugInfo: React.FC = () => {
  const { mode, tenantId, clientId } = useThemeContext();
  const inIframe = isInIframe();

  // Only show in development mode
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  return (
    <DebugContainer>
      <DebugTitle>🔍 Debug Info</DebugTitle>
      
      <DebugRow>
        <DebugLabel>In iFrame:</DebugLabel>
        <StatusBadge $active={inIframe}>
          {inIframe ? 'YES' : 'NO'}
        </StatusBadge>
      </DebugRow>

      <DebugRow>
        <DebugLabel>Theme:</DebugLabel>
        <DebugValue>{mode}</DebugValue>
      </DebugRow>

      <DebugRow>
        <DebugLabel>Tenant ID:</DebugLabel>
        <DebugValue>{tenantId || 'Not set'}</DebugValue>
      </DebugRow>

      <DebugRow>
        <DebugLabel>Client ID:</DebugLabel>
        <DebugValue>{clientId || 'Not set'}</DebugValue>
      </DebugRow>
    </DebugContainer>
  );
};
